<template>
  <div :class="wrapperClass">
    <template v-if="isoCode === 'en'">
      <img
        src="@/assets/flags/flag-en.gif"
        v-bind="imgProps"
      />
    </template>

    <template v-else-if="isoCode === 'pl'">
      <img
        src="@/assets/flags/flag-pl.gif"
        v-bind="imgProps"
      />
    </template>

    <template v-else-if="isoCode === 'de'">
      <img
        src="@/assets/flags/flag-de.gif"
        v-bind="imgProps"
      />
    </template>

    <template v-else>
      <img
        src="@/assets/flags/flag-xx.gif"
        v-bind="imgProps"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  isoCode: string
  variant?: 'default' | 'legacy'
}>()

const imgProps = {
  width: 24,
  height: 16,
  alt: ''
}

const wrapperClass = computed(() =>
  props.variant === 'legacy' ? 'nav-flag-icon nav-flag-icon--legacy' : 'nav-flag-icon'
)
</script>

<style lang="scss">
.nav-flag-icon {
  height: 16px;
  width: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border: 1px solid color(grey-300);
  border-radius: em(4px);
}

.nav-flag-icon--legacy {
  border: 1.2px solid var(--bg-200) !important;
  transition: border-color 0.2s;
}
</style>
